module.exports = __webpack_public_path__ + "img/Frame_21.4594bd45.png";